import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";
import { useSelector } from "react-redux";
import { AppState } from "store";

function useIncomingInvoicePermissions() {
  const { hasRelations, getIsRevisor } = useCheckRelations();
  const supplierInvoiceCreator = useSelector((store: AppState) => store.auth.selectedCompany.supplierInvoiceCreator);
  const supplierInvoiceViewer = useSelector((store: AppState) => store.auth.selectedCompany.supplierInvoiceViewer);

  const getHasIncomingInvoiceAdminPermission = (ignoreAdmin?: boolean) => {
    return hasRelations([AuthEnums.PersonCompanyRelationType.IncomingInvoicesAdmin], ignoreAdmin);
  };
  const getHasIncomingInvoiceSigneePermission = (ignoreAdmin?: boolean) => {
    return hasRelations([AuthEnums.PersonCompanyRelationType.IncomingInvoicesSignee], ignoreAdmin);
  };
  const getIncomingInvoiceUserPermissions = () => {
    return {
      hasInvoicePermissions: supplierInvoiceViewer,
      // Classifies unassigned invoices awaiting first attest, which the first-attest role handles too.
      isInvoiceAdmin: hasRelations([
        AuthEnums.PersonCompanyRelationType.IncomingInvoicesAdmin,
        AuthEnums.PersonCompanyRelationType.IncomingInvoicesCertifyAdmin,
      ]),
      isSignee: getHasIncomingInvoiceSigneePermission(),
    };
  };

  const canViewCharts = supplierInvoiceViewer && !getIsRevisor();

  return {
    canCreateIncomingInvoices: supplierInvoiceCreator,
    canViewIncomingInvoices: supplierInvoiceViewer,
    canViewCharts,
    getHasIncomingInvoiceAdminPermission,
    getHasIncomingInvoiceSigneePermission,
    getIncomingInvoiceUserPermissions,
  };
}

export default useIncomingInvoicePermissions;
